module.exports = __webpack_public_path__ + "static/media/LearnHead.237a80b4.png";